

export class  NewMaintenance
{
    id: number;
 visitdetails : string;
 dateofvisit : Date; 
 user : number; 
 client : number;
 machine : number ; 
 counter : number ; 
}